import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ModalRef, ModalService} from "ng-zorro-antd-mobile";
import {Subscription} from "rxjs";
import {BaseUserInterface, ComponentOption, DeptInterface} from "./dept.interface";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {YzSelectContactsService} from './yz-select-contacts.service';

@Component({
  selector: 'yz-select-contacts',
  templateUrl: './yz-select-contacts.component.html',
  styleUrls: ['./yz-select-contacts.component.less']
})
export class YzSelectContactsComponent implements OnInit, OnDestroy {

  modalRefCpt: Array<ModalRef> = [];
  subscribed: Array<Subscription> = [];
  dtPullToRefreshStyle = {height: window.innerHeight - 44 - 51 + 'px'};

  // 总部门数据
  deptNodes: Array<DeptInterface> = [];

  // 页面展示的部门数据
  deptList: Array<DeptInterface> = [];

  // 面包屑
  deptBarList: Array<DeptInterface> = [];

  // 页面加载中
  pageLoading: boolean = false;

  // 人员列表参数
  baseUserParams = {
    total: 0,
    pageSize: 20,
    pageNum: 1,
    deptId: null,
    realName: null,
    userTypes: null
  };

  // 人员数据
  baseUserList: Array<BaseUserInterface> = [];

  // 是否全选人员
  allUserCheck: boolean = false;

  // 已选择的联系人
  selectedContacts: Array<BaseUserInterface> = [];

  // 年级数据
  gradeList: Array<{ value: string, label: string }> = [];
  gradeParams: Array<{ value: string, label: string }> = [];

  constructor(
    public dialogRef: MatDialogRef<YzSelectContactsComponent>,
    private _modal: ModalService,
    private yzContactsService: YzSelectContactsService,
    @Inject(MAT_DIALOG_DATA) public data: ComponentOption
  ) {}

  ngOnInit() {
    if (this.data.onlyStudent === true) {
      this.baseUserParams.userTypes = '2,3';
      this.dtPullToRefreshStyle = {height: window.innerHeight - 44 - 51 - 44 + 'px'};
      this.initDeptOnlyStu();
      this.queryGrade();
    } else {
      this.baseUserParams.userTypes = this.data.userTypes;
      this.dtPullToRefreshStyle = {height: window.innerHeight - 44 - 51 + 'px'};
      this.initDept();
    }
  }

  // 查询部门树
  initDept() {
    this.deptList = [];
    this.deptNodes = [];
    this.pageLoading = true;
    const $temp = this.yzContactsService.getDeptTree(this.data.includeClass, this.data.includeHisClass).subscribe((dept: Array<DeptInterface>) => {
      this.pageLoading = false;
      this.deptNodes = dept;
      this.deptList = JSON.parse(JSON.stringify(this.deptNodes));

      this.queryDefaultContact();

      this.blDeptTree(this.deptList);
      this.blDeptTree(this.deptNodes);
      this.subscribed.push($temp);
    }, () => {
      this.pageLoading = false;
    });
  }

  // 查询部门->只选学生
  initDeptOnlyStu(): void {
    this.deptList = [];
    this.deptNodes = [];
    this.pageLoading = true;
    let gradeId = null;
    if (this.gradeParams.length > 0) {
      gradeId = this.gradeParams[0].value;
    }

    const $temp = this.yzContactsService.getDeptTreeOnlyStu(gradeId, this.data.includeClass, this.data.includeHisClass).subscribe((dept: Array<DeptInterface>) => {
      this.pageLoading = false;

      this.deptNodes = dept;
      this.deptList = JSON.parse(JSON.stringify(this.deptNodes));
      this.queryDefaultContact();

      this.blDeptTree(this.deptList);
      this.blDeptTree(this.deptNodes);

      this.subscribed.push($temp);
    }, () => {
      this.pageLoading = false;
    });
  }

  // 查询年级
  queryGrade() {
    this.gradeList = [];
    this.pageLoading = true;
    const $temp = this.yzContactsService.getGrade().subscribe((data: Array<any>) => {
      this.pageLoading = false;
      this.gradeList = [];
      data.forEach((item) => {
        if(item.enable !== 0 && item.enable !== null){
          this.gradeList.push({
            value: item.openId,
            label: item.name
          })
        }
      });

      this.gradeList.unshift({
        value: null,
        label: '全部'
      });

      this.subscribed.push($temp);
    }, () => {
      this.pageLoading = false;
      this.gradeList.unshift({
        value: null,
        label: '全部'
      });
    });
  }


  // 遍历部门树，确定叶子节点
  blDeptTree(tree) {
    if (tree && tree.length && tree.length > 0) {
      tree.forEach((item) => {
        item.expanded = true;
        if (item.children === null || item.children.length === 0) {
          item['isLeaf'] = true;
        } else {
          item['isLeaf'] = false;
        }

        this.blDeptTree(item.children);
      })
    }
  }

  // 查询默认已被选择人员的信息
  queryDefaultContact() {
    if (this.data.defaultContacts && this.data.defaultContacts.length > 0) {
      const userIdsArray: Array<any> = [];
      this.data.defaultContacts.forEach((item) => {
        if (item.userId) {
          userIdsArray.push(item.userId);
        }
      });
      this.pageLoading = true;
      const $temp = this.yzContactsService.getUserByUserIds(userIdsArray).subscribe((data: Array<BaseUserInterface>) => {
        this.pageLoading = false;
        this.selectedContacts = data;
        this.queryBaseUser();
        this.subscribed.push($temp);
      }, () => {
        this.pageLoading = false;
      });
    } else {
      this.queryBaseUser();
    }
  }

  // 查询人员列表
  queryBaseUser() {
    this.pageLoading = true;
    const $temp = this.yzContactsService.getBaseUser(
      this.baseUserParams.pageNum,
      this.baseUserParams.pageSize,
      this.baseUserParams.realName,
      this.baseUserParams.deptId,
      this.baseUserParams.userTypes
    ).subscribe((data: any) => {
      this.pageLoading = false;
      this.baseUserParams.total = data.total;
      this.baseUserList.push(...data.list);
      this.baseUserList.forEach((item) => {
        item['checked'] = false;
        item['disabled'] = false;
        if (!item.dept) {
          item.dept = {deptName: '暂无部门'}
        }
        if (!item.realName) {
          item.realName = '暂无姓名';
        }
        if (!item.userCode) {
          item.realName = '暂无学/工号'
        }
        if (!item.roles) {
          item.roles = [];
          item.rolesData = '暂无角色';
        } else {
          const roleArray = [];
          item.roles.forEach((value) => {
            roleArray.push(value.roleName);
          });
          item.rolesData = roleArray.toString();
        }
        this.selectedContacts.forEach((value) => {
          if (value.userId === item.userId) {
            item['checked'] = true;
          }
        });
      });
      this.isMaxCount();

      this.subscribed.push($temp);
    }, () => {
      this.pageLoading = false;
    });
  }

  // 刷新回调函数
  pullToRefresh() {
    if (this.baseUserList.length < this.baseUserParams.total) {
      this.baseUserParams.pageNum++;
      this.queryBaseUser();
    }
  }

  // 根据用户姓名即时搜索人员
  queryUserByRealName() {
    this.baseUserParams.pageNum = 1;
    this.baseUserList = [];
    this.queryBaseUser();
  }

  // 取消——根据用户姓名即时搜索人员
  cancelQueUserByRealName() {
    this.baseUserParams.realName = null;
    this.baseUserParams.pageNum = 1;
    this.baseUserList = [];
    this.queryBaseUser();
  }


  // 查询全部人员
  viewAllList() {
    this.deptList = JSON.parse(JSON.stringify(this.deptNodes));
    this.deptBarList = [];

    this.baseUserParams.deptId = '';
    this.baseUserParams.pageNum = 1;
    this.baseUserList = [];
    this.queryBaseUser();
  }

  // 顶部面包屑查看部门详细
  deptBarviewList(item: any, index: number) {
    if (index != this.deptBarList.length - 1) {
      this.deptList = item.children;
      this.deptBarList.length = index + 1;

      this.baseUserParams.deptId = item.key;
      this.baseUserParams.pageNum = 1;
      this.baseUserList = [];
      this.queryBaseUser();
    }
  }

  // 查看子部门 -> 查询当前部门人员
  viewDeptChildrenList(item) {
    if (item.isLeaf) { // 是叶子节点,无子部门
      this.deptList = [];
    } else {
      this.deptList = item.children;
    }

    this.deptBarList.push(item);

    this.baseUserParams.deptId = item.key;
    this.baseUserParams.pageNum = 1;
    this.baseUserList = [];
    this.queryBaseUser();
  }

  // 人员选择变化的回调
  userCheckedChange($event) {
    if ($event.checked) { // 选中
      this.allUserCheck = this.baseUserList.every((item) => {
        return item.checked === true;
      });

    } else { // 取消
      let itemIndex = 0;
      this.selectedContacts.forEach((value, index) => {
        if (value.userId === $event.value) {
          itemIndex = index;
        }
      });
      this.deleteContact($event.value, itemIndex);
    }

    this.addBaseUser();
  }

  // 将人员列表中选中项添加至已选择的人员列表中
  addBaseUser() {
    this.baseUserList.forEach((item) => {
      const hasThisMen = this.selectedContacts.some((value) => {
        return value.userId === item.userId
      });
      if (item.checked && !hasThisMen) {
        this.selectedContacts.push(item);
      }
    });

    this.isMaxCount();
  }

  // 人数选择达到最大值
  isMaxCount() {
    if (this.data.count > 0 && this.selectedContacts.length >= this.data.count) {
      this.selectedContacts.length = this.data.count;
      this.baseUserList.forEach((item) => {
        const hasThisUser = this.selectedContacts.some((value) => {
          return item.userId === value.userId
        });

        if (!hasThisUser) {
          item.checked = false;
          item.disabled = true;
        }
      })
    } else {
      this.baseUserList.forEach((item) => {
        item.disabled = false;
      })
    }

    if (this.baseUserList.length == 0) {
      this.allUserCheck = false;
    } else {
      this.allUserCheck = this.baseUserList.every((item) => {
        return item.checked === true;
      });
    }
  }

  // 删除联系人
  deleteContact(id, index) {
    this.selectedContacts.splice(index, 1);
    this.baseUserList.forEach((item) => {
      if (item.userId === id) {
        item.checked = false;
      }
    });
    if (this.baseUserList.length == 0) {
      this.allUserCheck = false;
    } else {
      this.allUserCheck = this.baseUserList.every((item) => {
        return item.checked === true;
      });
    }
  }


  // 全选
  allSelect() {
    this.allUserCheck = true;
    this.baseUserList.forEach((item) => {
      item.checked = true;
    });
    this.addBaseUser();
  }

  // 取消全选
  cancelAllSelect() {
    this.allUserCheck = false;
    this.baseUserList.forEach((item) => {
      let itemIndex = 0;
      this.selectedContacts.forEach((value, index) => {
        if (value.userId === item.userId) {
          itemIndex = index;
        }
      });
      this.deleteContact(item.userId, itemIndex);
    })
  }

  // 切换年级
  onChangeGrade($event) {
    if ($event && $event.length && $event.length > 0) {
      this.gradeParams = $event;
    } else {
      this.gradeParams = [{
        value: null,
        label: '全部'
      }];
    }

    this.deptBarList = [];
    this.baseUserParams.deptId = '';
    this.baseUserParams.pageNum = 1;
    this.baseUserList = [];

    this.initDeptOnlyStu();

  }

  // 点“完成”按钮，完成人员选择
  confirmSelect() {
    this.dialogRef.close(this.selectedContacts);
  }

  ngOnDestroy(): void {
    this.subscribed.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });

    this.modalRefCpt.forEach((ref: ModalRef) => {
      ref.destroy();
    });
  }
}
